(() => {
  if (window.zlProductMomentsControlsReady) return;
  window.zlProductMomentsControlsReady = true;

  const instances = new WeakMap();

  function init(section) {
    if (instances.has(section)) return;
    const viewport = section.querySelector('.zl-product-moments__viewport');
    const items = Array.from(section.querySelectorAll('.zl-product-moments__item'));
    const previous = section.querySelector('[data-zl-moments-prev]');
    const next = section.querySelector('[data-zl-moments-next]');
    if (!viewport || !previous || !next || items.length < 2) return;

    const targetPosition = (item) => Math.max(0, item.getBoundingClientRect().left - items[0].getBoundingClientRect().left);
    const nearestIndex = () => items.reduce((best, item, index) =>
      Math.abs(targetPosition(item) - viewport.scrollLeft) < Math.abs(targetPosition(items[best]) - viewport.scrollLeft) ? index : best, 0);

    let frame = 0;
    const update = () => {
      frame = 0;
      const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      previous.disabled = viewport.scrollLeft <= 1;
      next.disabled = viewport.scrollLeft >= maxScroll - 1;
    };
    const scheduleUpdate = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };
    const move = (direction) => {
      const index = Math.min(items.length - 1, Math.max(0, nearestIndex() + direction));
      const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      viewport.scrollTo({
        left: Math.min(maxScroll, targetPosition(items[index])),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    };
    const onPrevious = () => move(-1);
    const onNext = () => move(1);

    previous.addEventListener('click', onPrevious);
    next.addEventListener('click', onNext);
    viewport.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(scheduleUpdate) : null;
    observer?.observe(viewport);
    update();

    instances.set(section, () => {
      previous.removeEventListener('click', onPrevious);
      next.removeEventListener('click', onNext);
      viewport.removeEventListener('scroll', scheduleUpdate);
      window.removeEventListener('resize', scheduleUpdate);
      observer?.disconnect();
      if (frame) cancelAnimationFrame(frame);
    });
  }

  function initAll(root) {
    if (root.matches?.('[data-zl-moments]')) init(root);
    root.querySelectorAll?.('[data-zl-moments]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('[data-zl-moments]');
    if (section) instances.get(section)?.();
  });
})();
